export default function EmptyDocument({className = ''}) {
    return (<svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path
            d="M7.99998 1.25V5.45H12.2M7.99998 1.25H2.4C2.0287 1.25 1.6726 1.3975 1.41005 1.66005C1.1475 1.9226 1 2.2787 1 2.65V13.85C1 14.2213 1.1475 14.5774 1.41005 14.8399C1.6726 15.1025 2.0287 15.25 2.4 15.25H10.8C11.1713 15.25 11.5274 15.1025 11.7899 14.8399C12.0525 14.5774 12.2 14.2213 12.2 13.85L12.2 5.45M7.99998 1.25L12.2 5.45"
            stroke="current" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>);
}
